import css from './SliderProgress.module.scss'
import React, { useLayoutEffect, useRef } from 'react'
import classNames from 'classnames'

import DataTestId from 'meta/dataTestId'

type Props = {
  activeCard: number
  totalCards: number
  setActiveCard: (cardNumber: number) => void
  selectedTicketIds?: number[]
  unusableTicketIds?: number[]
  addExtra?: boolean
}

const SliderProgress: React.FC<Props> = (props) => {
  const { activeCard, totalCards, setActiveCard, selectedTicketIds, unusableTicketIds, addExtra } = props

  const progressRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const progress = progressRef.current
    //@ts-ignore
    const child = progress.children[activeCard] as HTMLDivElement
    //@ts-ignore
    progress.scrollTo({
      //@ts-ignore
      left: Math.max(child.offsetLeft - progress.clientWidth / 2, 0),
      behavior: 'smooth',
      top: 0,
    })
  }, [activeCard])

  return (
    <div
      data-testid={DataTestId.bag.progressWrapper}
      className={classNames(css.wrapper, { [css.flexStart]: totalCards >= 7 })}
      ref={progressRef}
    >
      {[...Array(totalCards)]
        .map((_, i) => i + 1)
        .map((elem, idx) => (
          <div
            key={elem}
            data-testid={DataTestId.bag.progressCardNumber}
            className={classNames(css.item, {
              [css.used]: unusableTicketIds && unusableTicketIds.includes(idx),
              [css.active]: activeCard === idx,
              [css.selected]: selectedTicketIds && activeCard !== idx && selectedTicketIds.includes(idx),
            })}
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              setActiveCard(idx)
            }}
          >
            {idx + 1}
            {unusableTicketIds && unusableTicketIds.includes(idx) && <span className={css.bar}></span>}
          </div>
        ))}

      {addExtra && (
        <div
          key={totalCards + 1}
          className={classNames(css.item, css.extra, { [css.active]: activeCard === totalCards })}
          onClick={(event) => {
            event.preventDefault()
            event.stopPropagation()
            setActiveCard(totalCards)
          }}
        >
          {`+`}
        </div>
      )}
    </div>
  )
}

export default SliderProgress
